import { CustomerLiteModel } from 'api-hooks/customer';
import { ProductSaleModel } from 'api-hooks/product/sales';
import { ProjectLiteModel } from 'api-hooks/projects';
import { TourSaleDetailModel } from 'api-hooks/tour/tour-sale';
import { Expose, Type } from 'class-transformer';
import { SaleStatusEnum, SaleTransactionTypeEnum } from 'common/constants/enum';
import {
  CommonModel,
  MinimalCommonModel,
} from 'common/repositories/common.model';

import { ActivitySaleDetailModel } from './activity';
import { SaleModel } from './common';
import { CruiseSaleDetailModel } from './cruise';
import { HotelSaleHotelSaleItemModel } from './hotel';
import { FlightSaleDetailModel } from './ticket-sale';
import { DocumentSaleModel } from './travel-document';

export class SaleDetailModel extends SaleModel {
  //Flight
  @Expose({ name: 'flight_sales' })
  @Type(() => FlightSaleDetailModel)
  flightSales: FlightSaleDetailModel[];

  //Hotel
  @Expose({ name: 'hotel_sales' })
  @Type(() => HotelSaleHotelSaleItemModel)
  hotelSales: HotelSaleHotelSaleItemModel[];

  //Cruise
  @Expose({ name: 'cruise_sales' })
  @Type(() => CruiseSaleDetailModel)
  cruiseSales: CruiseSaleDetailModel[];

  //Activity
  @Expose({ name: 'activity_sales' })
  @Type(() => ActivitySaleDetailModel)
  activitySales: ActivitySaleDetailModel[];

  //Tour
  @Expose({ name: 'tour_sales' })
  @Type(() => TourSaleDetailModel)
  tourSales: TourSaleDetailModel[];

  //Document
  @Expose({ name: 'document_sales' })
  @Type(() => DocumentSaleModel)
  documentSales: DocumentSaleModel[];

  //Product
  @Expose({ name: 'product_sales' })
  @Type(() => ProductSaleModel)
  productSales: ProductSaleModel[];
}

export class TransactionalFootnoteTransactionableModel {
  id: string;
  type: 'Sale' | 'Purchase';
}

export class TransactionalFootnoteModel extends CommonModel {
  description: string;

  @Type(() => TransactionalFootnoteTransactionableModel)
  transactionable: TransactionalFootnoteTransactionableModel;

  @Type(() => MinimalCommonModel)
  employee: MinimalCommonModel;
}
export class SaleMinimalModel extends CommonModel {
  code: string | null;

  @Type(() => CustomerLiteModel)
  customer: CustomerLiteModel;

  description: string | null;
  number: string;

  @Type(() => ProjectLiteModel)
  project: ProjectLiteModel | null;

  @Expose({ name: 'ref_id' })
  refId: string;

  status: SaleStatusEnum;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  type: SaleTransactionTypeEnum;
}

export class getSalesInput {
  params: {
    page: number;
    limit?: number;
    filter?: string;
    sort?: string;
    q?: string;
    hasProject?: boolean;
  } & {
    transaction_type?: SaleTransactionTypeEnum;
  };
}

export class getSaleInput {
  id: string;
}

export class getTransactionalFootnoteInput {
  id: string;
}

export class TransactionalMutationInput {
  type: 'sales' | 'purchases';
  id: string;
  body: { description: string };
}
